import {Component, inject, Self} from '@angular/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {ReactiveFormsModule} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {captureException} from '@sentry/angular';
import {MatIcon} from '@angular/material/icon';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-basic-feedback-modal',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatIcon,
    NgOptimizedImage
  ],
  templateUrl: './basic-feedback-modal.component.html',
  styleUrl: './basic-feedback-modal.component.scss'
})
export class BasicFeedbackModalComponent {

  readonly dialogRef = inject(MatDialogRef<BasicFeedbackModalComponent>);

  data?: {
    isSuccess?: boolean;
    message?: string;
    closeButtonText?: string;
    actionButtonText?: string;
    actionButtonCallback?: () => void;
  } = inject(MAT_DIALOG_DATA);

  runAction() {
    try {
      if (this.data?.actionButtonCallback) {
        this.data.actionButtonCallback();
      }
    } catch (e) {
      captureException(e);
    }
    this.closeModal();
  }

  closeModal() {
    this.dialogRef.close();
  }
}
